export default __webpack_public_path__ + "static/media/kalahasti idol 2.8b5c7190.jpg";